import React from 'react';
import { Control, Errors } from 'react-redux-form';
import CustomSearchableSelect from './custom-searchable-select.component';
const { text: ControlText } = Control;

const CustomSearchableSelectWrapper = ({ fieldProp, ...restProps }) => {
  const CustomSearch = (props) => <CustomSearchableSelect {...props} />;
  const ErrorMessageComponent = (props) => {
      return <div>{props.children}</div>;
  };
  const ErrorBorderWrapper = (props) => {
      const isWarning = Object.keys(props.fieldValue.errors).some(r => r.includes("warning_"));
      return <div className={isWarning ? "" : "has-error"}></div>
  };
  return (
      <>
          <Errors model={fieldProp} wrapper={ErrorBorderWrapper} />
          <ControlText
              model={fieldProp}
              className="control-field"
              component={CustomSearch}
              {...restProps}
              persist={true}
          />
          <Errors model={fieldProp} className="control-errors" component={ErrorMessageComponent} />
      </>
  );
};

export default CustomSearchableSelectWrapper;
